<div class="row">
  <div class="col-12">
    <div class="card">
        <div class="card-header">
            <p>Service Edit Form</p>   
         </div>
         <div class="card-body">
          <form >
            <div class="form-group">
              <label>Service Name: {{name}}</label>
            </div>
            <div class="form-group">
                <label>Fees:</label>
                <input type="number" name="fees" id="fees" class="form-control" [(ngModel)]="fees">
              </div>
          </form>
         </div>
         <div class="card-footer">
           <div class="row">
             <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <button class="btn btn-success btn-block" (click)="confirmfees()">
                confirm
              </button>
             </div>
             <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <button class="btn btn-success3 btn-block" mat-dialog-close>
                    Cancel
                </button> 
            </div>
           </div>
         </div>
    </div>
     
  </div>
</div>

